export var TxType;
(function (TxType) {
    TxType["TxSent"] = "SENT";
    TxType["TxReceived"] = "RECEIVED";
})(TxType || (TxType = {}));
